<!-- 采购订单-成本分摊页 -->
<template>
    <div class="business-content-main" v-loading="loading">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title" @click="hideMsg()">
                <div>
                    <span>需分摊的成本【{{orderdData.OrderCode}}】</span>
                </div>
            </div>
            <div class="search-ctn" @click="hideMsg()">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px">
                    <div class="form-main" style="width: 100%">
                        <el-form-item label="分摊类型">
                            <el-select class="search-item" v-model="submitData.CalcType">
                                <el-option v-for="item in calcTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分摊总额">
                            <el-input-number disabled v-model="submitData.TotalAmount"></el-input-number>
                        </el-form-item>
                        <el-form-item label="更新采购价">
                            <el-switch v-model="submitData.IsUpdateCost"> </el-switch>
                        </el-form-item>
                        <div>
                            <el-button class="calc-btn btn-primary" @click="calcShare()">计算分摊</el-button>
                            <el-button class="calc-btn btn-primary" @click="submitConfirm()">保存分摊结果</el-button>
                            <el-button class="calc-btn" type="danger" v-if="isCanDel" @click="delShareCost()">清空分摊结果</el-button>
                        </div>
                    </div>
                    <div class="formData-bottom">
                        <div class="form-item" style="width: 100%">
                            <el-form-item label="分摊项目">
                                <div v-for="(item, index) in selfData" :key="index">
                                    <el-input class="search-item" size="medium" v-model="item.key" placeholder="请输入项目名称"></el-input><span style="margin: 0 16px">:</span
                                    ><el-input-number class="search-item" size="medium" :min="0" v-model="item.value" placeholder="请输入金额"></el-input-number>
                                    <img style="margin-left: 16px" @click="delSelfData(index)" v-if="selfData.length !== index + 1" src="../../../assets/images/del.png" />
                                    <img style="margin-left: 16px" @click="addSelfData(index)" v-if="selfData.length === index + 1" src="../../../assets/images/add.png" />
                                </div>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <!--   form     -->
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-show="!showOrderMsg && orderdData.EntpCusName">供应商：{{ orderdData.EntpCusName }}</span>
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="search-ctn" v-show="showOrderMsg">
                <el-form :model="orderdData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px">
                    <div class="form-main" style="width: 100%">
                        <el-form-item label="供应商" prop="EntpCusId">
                            <el-input disabled v-model.trim="orderdData.EntpCusName"></el-input>
                        </el-form-item>
                        <el-form-item label="采购员" prop="SId">
                            <el-input disabled v-model.trim="orderdData.SName"></el-input>
                        </el-form-item>
                        <el-form-item label="运输费用" prop="ShipAmount">
                            <el-input type="number" disabled min="0" v-model.trim="orderdData.ShipAmount"></el-input>
                        </el-form-item>
                        <el-form-item label="发货方式">
                            <el-input disabled v-model.trim="orderdData.ShipTypeName"></el-input>
                        </el-form-item>
                        <el-form-item label="结算方式" prop="PayType">
                            <el-input disabled v-model.trim="orderdData.PayTypeName"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-bottom">
                        <div class="addresscls">
                            <el-form-item label="入仓仓库" prop="WarehouseId" style="width: 40%">
                                <el-input :title="warehouse.WarehouseName" v-model="warehouse.WarehouseName" style="width: 100%" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="仓库地址" prop="WarehouseAddr" style="width: 60%">
                                <el-input :title="warehouse.Address" v-model="warehouse.Address" :disabled="true" style="width: 100%"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="备注" style="width: 100%">
                                <el-input style="width: 100%" :title="orderdData.Remark" :disabled="true" v-model.trim="orderdData.Remark"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>商品明细</div>
            </div>
            <!-- table body -->
            <div class="table-ctn" @click="hideMsg()">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="dataList"
                    ref="multipleTable"
                    :summary-method="getSummaries"
                    @selection-change="handleSelectionChange"
                    show-summary
                    :row-key="getRowKeys"
                    border
                    style="width: 100%"
                > 
                    <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                    <el-table-column show-overflow-tooltip width="60px" type="index" label="序号"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="170px" prop="APCode" label="汽配编码"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="200px" prop="GoodName" label="配件名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="160px" prop="AutoSerise" label="车型"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="Count" label="数量"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="Price" label="采购价"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ShareCost" label="分摊成本">
                        <template slot-scope="scope"
                            ><i style="color: red" v-if="scope.row.ShareCost > 0">{{ scope.row.ShareCost.toFixed(2) }}</i
                            ><i v-else>{{ scope.row.ShareCost.toFixed(2) }}</i></template
                        ></el-table-column
                    >
                    <el-table-column show-overflow-tooltip label="分摊总成本">
                        <template slot-scope="scope"
                            ><i style="color: red" v-if="scope.row.ShareCost > 0">{{ (scope.row.ShareCost * scope.row.Count).toFixed(2) }}</i
                            ><i v-else>{{ (scope.row.ShareCost * scope.row.Count).toFixed(2) }}</i></template
                        ></el-table-column
                    >
                    <el-table-column show-overflow-tooltip width="150px" label="分摊后采购价">
                        <template slot-scope="scope">{{ (scope.row.Price + scope.row.ShareCost).toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" label="采购总计">
                        <template slot-scope="scope">{{ ((scope.row.Price + scope.row.ShareCost) * scope.row.Count).toFixed(2) }}</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
export default {
	mixins: [mixin],
	name: '',
	components: {
		APMsg,
		breadcrumb,
	},
	data() {
		return {
			goodsId: '',
			mulSelection: null,
			APMsgVisible: false,
			showOrderMsg: false,
			dataReadonly: false,
			allNum: 1,
			allMoney: 0,
			editIndex: -1,
			loading: false,
			orderdData: {},
			submitData: {
				OrderId: '',
				CalcType: 0,
				CostItems: '',
				IsUpdateCost: false,
				TotalAmount: 0,
				ShareDatas: [],
			},
			id: '',
			pageTitle: '',
			permission: {},
			warehouse: [], //仓库地址
			dataList: [],
			calcTypeList: [{ Text: '按价值分摊', Value: 0 }, { Text: '按数量分摊', Value: 1 }],
			selfData: [
				// 自定义属性
			],
			isCanDel: false,
			shipAmount: 0,
		};
	},
	beforeRouteLeave(to, from, next) {
		this.$util.confirmBeforeLeave(to, from, next, this);
	},
	mounted() {
		this.id = this.$route.query.id;
		this.submitData.OrderId = this.$route.query.id;
		this.getOrderDetail();
	},
	methods: {
		// 配件信息
		hideMsg() {
			this.showOrderMsg = false;
		},
		showMsg() {
			this.showOrderMsg = true;
		},
		// 配件信息
		showAPMsgDialog(id) {
			if (id) {
				this.goodsId = id;
				this.APMsgVisible = true;
			}
		},
		closeAPMsgDialog(edit) {
			this.APMsgVisible = false;
			if (edit) {
				this.getOrderDetail();
			}
		},
		// 获取详情
		getOrderDetail() {
			let that = this;
			that.loading = true;
			that.$util
				.axiosGet({
					url: '/api/EntpPurchaseOrder/GetPurOrderShareCostDetails',
					data: {
						EntpCusPOId: that.id,
					},
					hideLoading: true,
				})
				.then((res) => {
					let data = res.data;
					that.orderdData = data;
					that.warehouse = data.Warehouse;
					that.dataList = data.DetailList;
					that.submitData.CalcType = data.CalcType;
					that.isCanDel = data.IsCanDel;
					that.shipAmount = data.ShipAmount;
					if (data.CostItems && data.CostItems.length > 0) {
						that.selfData = data.CostItems;
						let costTotal = 0;
						that.selfData.forEach((item) => {
							if (!isNaN(item.value)) {
								costTotal += Number(item.value);
							} else {
								costTotal += 0;
							}
						});
						that.submitData.TotalAmount = costTotal.toFixed(2);
					} else {
						this.selfData.push({
							key: '运费',
							value: data.ShipAmount,
						});
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
		calcShare() {
			let that = this;
			let costTotal = 0;
			let supTotal = 0;
			let supCount = 0;
			let list = that.dataList;
			if (that.selfData.length > 0) {
				that.selfData.forEach((item) => {
					if (!isNaN(item.value)) {
						costTotal += Number(item.value);
					} else {
						costTotal += 0;
					}
				});
				if (costTotal > 0) {
					that.submitData.ShareDatas = [];
					that.submitData.TotalAmount = costTotal.toFixed(2);

					if (that.mulSelection && that.mulSelection.length > 0) {
						that.mulSelection.forEach((item) => {
							supTotal += item.Price;
							supCount += item.Count;
						});

						that.dataList.forEach((item) => {
							item.ShareCost = 0;

							let index = that.mulSelection.findIndex((selectItem) => selectItem.RsId == item.RsId);
							if (index > -1) {
								if (that.submitData.CalcType == 0) {
									item.ShareCost = Number((item.Price * (costTotal / supTotal)) / item.Count);
								} else {
									item.ShareCost = Number(costTotal / supCount);
								}
							} else item.ShareCost = 0;
							that.submitData.ShareDatas.push({ RsId: item.RsId, ShareCost: item.ShareCost });
						});
					} else {
						list.forEach((item) => {
							supTotal += item.Price;
							supCount += item.Count;
						});

						that.dataList.forEach((item) => {
							if (that.submitData.CalcType == 0) {
								item.ShareCost = Number((item.Price * (costTotal / supTotal)) / item.Count);
							} else {
								item.ShareCost = Number(costTotal / supCount);
							}
							that.submitData.ShareDatas.push({ RsId: item.RsId, ShareCost: item.ShareCost });
						});
					}
				} else {
					that.submitData.TotalAmount = 0;
					that.$message.error('未检测到要计算的分摊的成本');
					return;
				}
			}
		},
		addSelfData() {
			this.selfData.push({
				key: '',
				value: '',
			});
		},
		delSelfData(index) {
			this.selfData.splice(index, 1);
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 4) {
					sums[index] = '合计：';
					return;
				}
				if (index === 7 || index === 5 || index === 6) {
					const values = data.map((item) => Number(item[column.property]));
					if (!values.every((value) => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index] = sums[index].toFixed(2) * 1;
					} else {
						sums[index] = '';
					}
				}
				if (index === 8) {
					sums[index] = this.submitData.TotalAmount.toFixed(2);
				}
				if (index === 9) {
					sums[index] = (Number(sums[7]) + Number(sums[6])).toFixed(2);
				}
				if (index === 10) {
					sums[index] = (Number(this.submitData.TotalAmount) + Number(this.orderdData.OrderAmount)).toFixed(2);
				}
			});

			return sums;
		},
		submitConfirm() {
			let that = this;
			that.calcShare();
			if (that.submitData.TotalAmount == 0) return;
			if (that.selfData) {
				that.submitData.CostItems = '';
				let list = that.selfData;
				let fIndex = list.findIndex((i) => (i.key && !i.value) || (!i.key && i.value));
				if (fIndex > -1) {
					that.$message.error('未填写任何的分摊项目');
					return;
				} else {
					let pendList = list.filter((i) => i.key && i.value);
					if (pendList.length > 0) {
						that.submitData.CostItems = pendList.reduce((p, i) => {
							return `${p ? p + '|' : ''}${i.key}:${i.value}`;
						}, '');
					}
				}
			}
			that.loading = true;
			that.$util
				.axiosPost({
					url: '/api/EntpPurchaseOrder/SubmitShareCostData',
					data: that.submitData,
					hideLoading: true,
				})
				.then((res) => {
					that.$util.successMsg(res.errmsg);
					that.isCanDel = true;
				})
				.finally(() => {
					that.loading = false;
				});
		},
		handleSelectionChange(val) {
			this.mulSelection = val;
		},
		// 记录每行的key值
		getRowKeys(row) {
			return row.RsId;
		},
		delShareCost() {
			let that = this;
			that.$util.elConfirm({
				content: '您确定要清空当前的分摊结果吗？清空后将无法恢复',
				noMsg: true,
				confirm() {
					that.loading = true;
					that.$util
						.axiosPost({
							url: `/api/EntpPurchaseOrder/DelShareCostData?orderId=` + that.id,
							hideLoading: true,
						})
						.then(() => {
							that.$util.successMsg('已成功清空分摊数据');
							that.submitData.TotalAmount = 0;
							that.isCanDel = false;
							that.selfData = [];
							that.selfData.push({
								key: '运费',
								value: that.shipAmount,
							});
							that.dataList.forEach((item) => {
								item.ShareCost = 0;
							});
						})
						.catch(() => {})
						.finally(() => {
							that.loading = false;
						});
				},
			});
		},
	},
};
</script>
<style lang="less" scoped>
.calc-btn {
	margin-left: 10px;
}
.payment-tip {
	position: absolute;
	left: 0;
	bottom: -18px;
	line-height: 1;
	font-size: 12px;
	color: @font4Color;
}
.search-ctn {
	border: 1px solid @border3Color;
	padding-top: 20px;
	margin-bottom: 20px;

	.el-form-item {
		margin-bottom: 10px;
	}
}
.form-main {
	display: flex;
	flex-direction: row;
	width: 100%;
	height: auto;
}
.form-bottom {
	width: 100%;
	display: flex;
	flex-direction: row;
	div {
		width: 50%;
	}
}
.section-title {
	display: flex;
	justify-content: space-between;
	height: 36px;
	line-height: 36px;
	padding: 0 20px;
	font-weight: bold;
	font-size: @font-sm;
	margin-left: -1px;
	background: @border3Color;
}
.edit-ctn {
	.div-table-cell {
		padding: 0 5px;
	}
}
.option-content {
	display: flex;
	line-height: 30px;

	.project-Name {
		width: 200px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 12px;
	}
}
.business-content-main {
	min-width: 1440px;
}
.table-main {
	position: relative;
}
.div-table-cell {
	display: flex;
	align-items: center;
	justify-content: center;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
.addresscls {
	display: flex;
	flex-direction: row;
}
</style>
<style lang="less">
.el-row {
	margin-bottom: 20px;
	&:last-child {
		margin-bottom: 20px;
	}
}
.el-col {
	border-radius: 4px;
}
.bg-purple-dark {
	background: #99a9bf;
}
.bg-purple {
	background: #d3dce6;
}
.bg-purple-light {
	background: #e5e9f2;
}
.grid-content {
	border-radius: 4px;
	min-height: 36px;
}
.row-bg {
	padding: 10px 0;
	background-color: #f9fafc;
}
.check-code-class {
	.el-input__inner {
		border: 1px solid #f56c6c;
	}
}
</style>
